<template>
  <div class="edit-tools">
    <div class="edit-tools__actions">
      <div class="tabs-row">
        <!-- cut tab -->
        <edit-tool-tab
          v-if="this.modalSourseList == false"
          class="tabs-row__tab"
          :is-selected="selectedOption == 'cut'"
          :disabledBtn="false"
          @click="select('cut')"
        >
          <template v-slot:icon>
            <content-cut />
          </template>
          <template v-slot:label>
            Cut
          </template>
        </edit-tool-tab>

        <!-- resize tab -->
        <edit-tool-tab
          v-if="modalSourseList == false && hasSudioMode == 'studioVideoEdit'"
          class="tabs-row__tab"
          :disabledBtn="buttonDisabled"
          :is-selected="selectedOption == 'crop'"
          @click="select('crop')"
        >
          <template v-slot:icon>
            <crop-free />
          </template>
          <template v-slot:label>
            Resize (crop)
          </template>
        </edit-tool-tab>

        <!-- audio tab -->
        <edit-tool-tab
          v-if="modalSourseList == false"
          class="tabs-row__tab"
          :disabledBtn="buttonDisabled"
          :is-selected="selectedOption == 'audio'"
          @click="select('audio')"
        >
          <template v-slot:icon>
            <volume-medium />
          </template>
          <template v-slot:label>
            Audio
          </template>
        </edit-tool-tab>

        <!-- templates tab -->
        <edit-tool-tab
          v-if="modalSourseList == false && hasSudioMode == 'studioVideoEdit'"
          class="tabs-row__tab"
          :disabledBtn="buttonDisabled"
          :is-selected="selectedOption == 'templates'"
          @click="select('templates')"
        >
          <template v-slot:icon>
            <image-size-select-large />
          </template>
          <template v-slot:label>
            Watermark
          </template>
        </edit-tool-tab>

        <!-- text tab -->
        <edit-tool-tab
          v-if="modalSourseList == false && hasSudioMode == 'studioVideoEdit'"
          class="tabs-row__tab"
          :disabledBtn="buttonDisabled"
          :is-selected="selectedOption == 'text'"
          @click="select('text')"
        >
          <template v-slot:icon>
            <format-textbox />
          </template>
          <template v-slot:label>
            Text
          </template>
        </edit-tool-tab>
      </div>
    </div>

    <div class="edit-tools__save">
      <div class="edit-save-btn">
        <el-button
          v-loading="isEditLoading"
          :disabled="buttonDisabled || disabledBtnSaveEdits == true"
          type="success"
          class="btn"
          spinner="save-spinner"
          @click="handleEditing"
        >
          <span
            class="save-text"
            :style="{ color: isEditLoading ? 'transparent' : 'white' }"
          >
            Save Edits
          </span>
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import EditToolTab from "@/components/media/editing/EditToolTab.vue";
/** icons */
import CropFree from "vue-material-design-icons/CropFree.vue";
import VolumeMedium from "vue-material-design-icons/VolumeMedium.vue";
import FormatTextbox from "vue-material-design-icons/FormatTextbox.vue";
import ImageSizeSelectLarge from "vue-material-design-icons/ImageSizeSelectLarge.vue";
import ContentCut from "vue-material-design-icons/ContentCut.vue";
import { mapGetters } from "vuex";

// @group Editing
// Edit tools selecting bar
export default {
  name: "EditToolsBar",
  components: {
    EditToolTab,
    /** Material Design Icons */
    CropFree,
    VolumeMedium,
    FormatTextbox,
    ImageSizeSelectLarge,
    ContentCut
  },
  computed: {
    ...mapGetters(["hasSudioMode"]),
  },
  props: {
    disabledBtnSaveEdits: {
      type: Boolean,
      default: false,
    },
    prosentageDragEndDrop: {
      type: Number,
      default: 0
    },
    mediaCuts: {
      type: Array,
      default: null
    },
    modalSourseList: {
      type: Boolean,
      default: true
    },
    // @vuese
    // Selected tool name (crop, audio, text, templates, cut)
    selected: {
      type: String,
      default: "crop",
      validator(val) {
        const tools = ["crop", "audio", "text", "templates", "cut"];
        return tools.includes(val);
      }
    },
    // @vuese
    // is edit button processing
    isEditLoading: {
      type: Boolean,
      required: false,
      default: false
    },
    // @vuese
    // is edit button disabled
    isEditDisabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      selectedOption: this.selected,
      buttonDisabled: true
    };
  },
  watch: {
    prosentageDragEndDrop() {
      if (this.prosentageDragEndDrop > 0 && this.prosentageDragEndDrop < 100) {
        this.buttonDisabled = true;
      } else {
        this.buttonDisabled = false;
      }
    },
    mediaCuts() {
      // this.buttonDisabled = !this.buttonDisabled;
      if (this.mediaCuts !== null && this.mediaCuts.length !== 0) {
        this.buttonDisabled = false;
      } else {
        this.buttonDisabled = true;
      }
    },
    selected() {
      this.selectedOption = this.selected;
    },
    cutMod() {
      if (this.cutMod == true) {
        this.select("cut");
      }
    },
    selectedOption() {
      if (this.selectedOption !== "cut") {
        this.$emit("shangeMode");
      }
    }
  },
  methods: {
    // @vuese
    // Change selected tool
    select(option) {
      this.selectedOption = option;
      this.$emit("selectedOption", option);
    },
    // @vuese
    // Edit video
    handleEditing() {
      this.$emit("edit");
    }
  }
};
</script>
<style>
.save-text {
  /* font-family: sans-serif; */
}
:root {
  /** colors */
  --dark-grey: #3d3d3d;
  --grey: #5b5b5b;
  --light-grey: #878787;

  /** layers for modals */
  --modal-dropdown-z: 3200;
  --modal-z: 3150;
  --modal-backdrop-z: 3100;

  /** layer for notifications panel */
  --notifs-z: 3000;

  /** navigation bar layers */
  --navbar-dropdown-z: 2050;
  --navbar-z: 2000;

  --video-thumb-overlay-z: 50;

  /** player layers */
  --player-z: 50;
  --player-controls-z: 100;

  /** areas */
  --edit-area-z: 50;

  /** timeine layers */
  --timeline-popup-z: 300;
  --timeline-cursor-z: 120;
  --timeline-break-z: 20;

  /** left handle wrapper should to have more z-index to prevent ovelaying from right handle wrapper */
  --timeline-left-handle-z: 16;
  --timeline-right-handle-z: 15;
  --timeline-slider-z: 15;
  --timeline-faded-z: 20;
  --timeline-label-z: 10;
  --timeline-duration-z: 30;
  --timeline-button-z: 170;
}
.el-button.btn,
/* .el-button.is-disabled, */
/* .el-button.is-disabled.btn, */
.el-button--success.btn,
/* .el-button.is-disabled:hover.btn, */
/* .el-button.is-disabled:focus.btn, */
/* .el-button.is-disabled:hover, */
.el-button.is-disabled:focus {
  background-color: #ed5229 !important;
  border: none;
}
</style>

<style lang="scss" scoped>
.edit-tools {
  display: flex;
  align-items: center;
  padding-bottom: 2em;

  &__actions {
    flex-grow: 1;

    display: flex;
    justify-content: flex-start;
  }
}

.tabs-row {
  display: flex;
  justify-content: center;

  &__tab {
    margin-right: 5px;

    .material-design-icon .material-design-icon__svg {
      height: 1.7rem !important;
      width: 1.7rem !important;
    }
  }
}
.edit-save-btn {
  align-self: center;
  margin-left: auto;
  margin-right: 10px;
}
</style>
